export default __webpack_public_path__ + "static/media/utep.3b6bd084.png";